import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteEvent($id: Int!) {
    deleteEvent(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteEvent: {
    id?: number;
  };
}
